// TODO: hardcode backend response
export const timeZonesList = {
  timeZones: [
    {
      displayName: '(UTC-12:00) International Date Line West',
      ianaTimeZoneId: 'Etc/GMT+12',
      windowsTimeZoneId: 'Dateline Standard Time',
    },
    {
      displayName: '(UTC-11:00) Coordinated Universal Time-11',
      ianaTimeZoneId: 'Etc/GMT+11',
      windowsTimeZoneId: 'UTC-11',
    },
    {
      displayName: '(UTC-10:00) Aleutian Islands',
      ianaTimeZoneId: 'America/Adak',
      windowsTimeZoneId: 'Aleutian Standard Time',
    },
    {
      displayName: '(UTC-10:00) Hawaii',
      ianaTimeZoneId: 'Pacific/Honolulu',
      windowsTimeZoneId: 'Hawaiian Standard Time',
    },
    {
      displayName: '(UTC-09:30) Marquesas Islands',
      ianaTimeZoneId: 'Pacific/Marquesas',
      windowsTimeZoneId: 'Marquesas Standard Time',
    },
    {
      displayName: '(UTC-09:00) Alaska',
      ianaTimeZoneId: 'America/Anchorage',
      windowsTimeZoneId: 'Alaskan Standard Time',
    },
    {
      displayName: '(UTC-09:00) Coordinated Universal Time-09',
      ianaTimeZoneId: 'Etc/GMT+9',
      windowsTimeZoneId: 'UTC-09',
    },
    {
      displayName: '(UTC-08:00) Baja California',
      ianaTimeZoneId: 'America/Tijuana',
      windowsTimeZoneId: 'Pacific Standard Time (Mexico)',
    },
    {
      displayName: '(UTC-08:00) Coordinated Universal Time-08',
      ianaTimeZoneId: 'Etc/GMT+8',
      windowsTimeZoneId: 'UTC-08',
    },
    {
      displayName: '(UTC-08:00) Pacific Time (US & Canada)',
      ianaTimeZoneId: 'America/Los_Angeles',
      windowsTimeZoneId: 'Pacific Standard Time',
    },
    {
      displayName: '(UTC-07:00) Arizona',
      ianaTimeZoneId: 'America/Phoenix',
      windowsTimeZoneId: 'US Mountain Standard Time',
    },
    {
      displayName: '(UTC-07:00) La Paz, Mazatlan',
      ianaTimeZoneId: 'America/Mazatlan',
      windowsTimeZoneId: 'Mountain Standard Time (Mexico)',
    },
    {
      displayName: '(UTC-07:00) Mountain Time (US & Canada)',
      ianaTimeZoneId: 'America/Denver',
      windowsTimeZoneId: 'Mountain Standard Time',
    },
    {
      displayName: '(UTC-07:00) Yukon',
      ianaTimeZoneId: 'America/Whitehorse',
      windowsTimeZoneId: 'Yukon Standard Time',
    },
    {
      displayName: '(UTC-06:00) Central America',
      ianaTimeZoneId: 'America/Guatemala',
      windowsTimeZoneId: 'Central America Standard Time',
    },
    {
      displayName: '(UTC-06:00) Central Time (US & Canada)',
      ianaTimeZoneId: 'America/Chicago',
      windowsTimeZoneId: 'Central Standard Time',
    },
    {
      displayName: '(UTC-06:00) Easter Island',
      ianaTimeZoneId: 'Pacific/Easter',
      windowsTimeZoneId: 'Easter Island Standard Time',
    },
    {
      displayName: '(UTC-06:00) Guadalajara, Mexico City, Monterrey',
      ianaTimeZoneId: 'America/Mexico_City',
      windowsTimeZoneId: 'Central Standard Time (Mexico)',
    },
    {
      displayName: '(UTC-06:00) Saskatchewan',
      ianaTimeZoneId: 'America/Regina',
      windowsTimeZoneId: 'Canada Central Standard Time',
    },
    {
      displayName: '(UTC-05:00) Bogota, Lima, Quito, Rio Branco',
      ianaTimeZoneId: 'America/Bogota',
      windowsTimeZoneId: 'SA Pacific Standard Time',
    },
    {
      displayName: '(UTC-05:00) Chetumal',
      ianaTimeZoneId: 'America/Cancun',
      windowsTimeZoneId: 'Eastern Standard Time (Mexico)',
    },
    {
      displayName: '(UTC-05:00) Eastern Time (US & Canada)',
      ianaTimeZoneId: 'America/New_York',
      windowsTimeZoneId: 'Eastern Standard Time',
    },
    {
      displayName: '(UTC-05:00) Haiti',
      ianaTimeZoneId: 'America/Port-au-Prince',
      windowsTimeZoneId: 'Haiti Standard Time',
    },
    {
      displayName: '(UTC-05:00) Havana',
      ianaTimeZoneId: 'America/Havana',
      windowsTimeZoneId: 'Cuba Standard Time',
    },
    {
      displayName: '(UTC-05:00) Indiana (East)',
      ianaTimeZoneId: 'America/Indiana/Indianapolis',
      windowsTimeZoneId: 'US Eastern Standard Time',
    },
    {
      displayName: '(UTC-05:00) Turks and Caicos',
      ianaTimeZoneId: 'America/Grand_Turk',
      windowsTimeZoneId: 'Turks And Caicos Standard Time',
    },
    {
      displayName: '(UTC-04:00) Asuncion',
      ianaTimeZoneId: 'America/Asuncion',
      windowsTimeZoneId: 'Paraguay Standard Time',
    },
    {
      displayName: '(UTC-04:00) Atlantic Time (Canada)',
      ianaTimeZoneId: 'America/Halifax',
      windowsTimeZoneId: 'Atlantic Standard Time',
    },
    {
      displayName: '(UTC-04:00) Caracas',
      ianaTimeZoneId: 'America/Caracas',
      windowsTimeZoneId: 'Venezuela Standard Time',
    },
    {
      displayName: '(UTC-04:00) Cuiaba',
      ianaTimeZoneId: 'America/Cuiaba',
      windowsTimeZoneId: 'Central Brazilian Standard Time',
    },
    {
      displayName: '(UTC-04:00) Georgetown, La Paz, Manaus, San Juan',
      ianaTimeZoneId: 'America/La_Paz',
      windowsTimeZoneId: 'SA Western Standard Time',
    },
    {
      displayName: '(UTC-04:00) Santiago',
      ianaTimeZoneId: 'America/Santiago',
      windowsTimeZoneId: 'Pacific SA Standard Time',
    },
    {
      displayName: '(UTC-03:30) Newfoundland',
      ianaTimeZoneId: 'America/St_Johns',
      windowsTimeZoneId: 'Newfoundland Standard Time',
    },
    {
      displayName: '(UTC-03:00) Araguaina',
      ianaTimeZoneId: 'America/Araguaina',
      windowsTimeZoneId: 'Tocantins Standard Time',
    },
    {
      displayName: '(UTC-03:00) Brasilia',
      ianaTimeZoneId: 'America/Sao_Paulo',
      windowsTimeZoneId: 'E. South America Standard Time',
    },
    {
      displayName: '(UTC-03:00) Cayenne, Fortaleza',
      ianaTimeZoneId: 'America/Cayenne',
      windowsTimeZoneId: 'SA Eastern Standard Time',
    },
    {
      displayName: '(UTC-03:00) City of Buenos Aires',
      ianaTimeZoneId: 'America/Argentina/Buenos_Aires',
      windowsTimeZoneId: 'Argentina Standard Time',
    },
    {
      displayName: '(UTC-03:00) Montevideo',
      ianaTimeZoneId: 'America/Montevideo',
      windowsTimeZoneId: 'Montevideo Standard Time',
    },
    {
      displayName: '(UTC-03:00) Punta Arenas',
      ianaTimeZoneId: 'America/Punta_Arenas',
      windowsTimeZoneId: 'Magallanes Standard Time',
    },
    {
      displayName: '(UTC-03:00) Saint Pierre and Miquelon',
      ianaTimeZoneId: 'America/Miquelon',
      windowsTimeZoneId: 'Saint Pierre Standard Time',
    },
    {
      displayName: '(UTC-03:00) Salvador',
      ianaTimeZoneId: 'America/Bahia',
      windowsTimeZoneId: 'Bahia Standard Time',
    },
    {
      displayName: '(UTC-02:00) Coordinated Universal Time-02',
      ianaTimeZoneId: 'Etc/GMT+2',
      windowsTimeZoneId: 'UTC-02',
    },
    {
      displayName: '(UTC-02:00) Greenland',
      ianaTimeZoneId: 'America/Nuuk',
      windowsTimeZoneId: 'Greenland Standard Time',
    },
    {
      displayName: '(UTC-02:00) Mid-Atlantic - Old',
      ianaTimeZoneId: 'Etc/GMT+2',
      windowsTimeZoneId: 'Mid-Atlantic Standard Time',
    },
    {
      displayName: '(UTC-01:00) Azores',
      ianaTimeZoneId: 'Atlantic/Azores',
      windowsTimeZoneId: 'Azores Standard Time',
    },
    {
      displayName: '(UTC-01:00) Cabo Verde Is.',
      ianaTimeZoneId: 'Atlantic/Cape_Verde',
      windowsTimeZoneId: 'Cape Verde Standard Time',
    },
    {
      displayName: '(UTC) Coordinated Universal Time',
      ianaTimeZoneId: 'Etc/UTC',
      windowsTimeZoneId: 'UTC',
    },
    {
      displayName: '(UTC+00:00) Dublin, Edinburgh, Lisbon, London',
      ianaTimeZoneId: 'Europe/London',
      windowsTimeZoneId: 'GMT Standard Time',
    },
    {
      displayName: '(UTC+00:00) Monrovia, Reykjavik',
      ianaTimeZoneId: 'Africa/Abidjan',
      windowsTimeZoneId: 'Greenwich Standard Time',
    },
    {
      displayName: '(UTC+00:00) Sao Tome',
      ianaTimeZoneId: 'Africa/Sao_Tome',
      windowsTimeZoneId: 'Sao Tome Standard Time',
    },
    {
      displayName: '(UTC+01:00) Casablanca',
      ianaTimeZoneId: 'Africa/Casablanca',
      windowsTimeZoneId: 'Morocco Standard Time',
    },
    {
      displayName: '(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna',
      ianaTimeZoneId: 'Europe/Berlin',
      windowsTimeZoneId: 'W. Europe Standard Time',
    },
    {
      displayName: '(UTC+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague',
      ianaTimeZoneId: 'Europe/Budapest',
      windowsTimeZoneId: 'Central Europe Standard Time',
    },
    {
      displayName: '(UTC+01:00) Brussels, Copenhagen, Madrid, Paris',
      ianaTimeZoneId: 'Europe/Paris',
      windowsTimeZoneId: 'Romance Standard Time',
    },
    {
      displayName: '(UTC+01:00) Sarajevo, Skopje, Warsaw, Zagreb',
      ianaTimeZoneId: 'Europe/Warsaw',
      windowsTimeZoneId: 'Central European Standard Time',
    },
    {
      displayName: '(UTC+01:00) West Central Africa',
      ianaTimeZoneId: 'Africa/Lagos',
      windowsTimeZoneId: 'W. Central Africa Standard Time',
    },
    {
      displayName: '(UTC+02:00) Athens, Bucharest',
      ianaTimeZoneId: 'Europe/Bucharest',
      windowsTimeZoneId: 'GTB Standard Time',
    },
    {
      displayName: '(UTC+02:00) Beirut',
      ianaTimeZoneId: 'Asia/Beirut',
      windowsTimeZoneId: 'Middle East Standard Time',
    },
    {
      displayName: '(UTC+02:00) Cairo',
      ianaTimeZoneId: 'Africa/Cairo',
      windowsTimeZoneId: 'Egypt Standard Time',
    },
    {
      displayName: '(UTC+02:00) Chisinau',
      ianaTimeZoneId: 'Europe/Chisinau',
      windowsTimeZoneId: 'E. Europe Standard Time',
    },
    {
      displayName: '(UTC+02:00) Gaza, Hebron',
      ianaTimeZoneId: 'Asia/Hebron',
      windowsTimeZoneId: 'West Bank Standard Time',
    },
    {
      displayName: '(UTC+02:00) Harare, Pretoria',
      ianaTimeZoneId: 'Africa/Johannesburg',
      windowsTimeZoneId: 'South Africa Standard Time',
    },
    {
      displayName: '(UTC+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius',
      ianaTimeZoneId: 'Europe/Kyiv',
      windowsTimeZoneId: 'FLE Standard Time',
    },
    {
      displayName: '(UTC+02:00) Jerusalem',
      ianaTimeZoneId: 'Asia/Jerusalem',
      windowsTimeZoneId: 'Israel Standard Time',
    },
    {
      displayName: '(UTC+02:00) Juba',
      ianaTimeZoneId: 'Africa/Juba',
      windowsTimeZoneId: 'South Sudan Standard Time',
    },
    {
      displayName: '(UTC+02:00) Kaliningrad',
      ianaTimeZoneId: 'Europe/Kaliningrad',
      windowsTimeZoneId: 'Kaliningrad Standard Time',
    },
    {
      displayName: '(UTC+02:00) Khartoum',
      ianaTimeZoneId: 'Africa/Khartoum',
      windowsTimeZoneId: 'Sudan Standard Time',
    },
    {
      displayName: '(UTC+02:00) Tripoli',
      ianaTimeZoneId: 'Africa/Tripoli',
      windowsTimeZoneId: 'Libya Standard Time',
    },
    {
      displayName: '(UTC+02:00) Windhoek',
      ianaTimeZoneId: 'Africa/Windhoek',
      windowsTimeZoneId: 'Namibia Standard Time',
    },
    {
      displayName: '(UTC+03:00) Amman',
      ianaTimeZoneId: 'Asia/Amman',
      windowsTimeZoneId: 'Jordan Standard Time',
    },
    {
      displayName: '(UTC+03:00) Baghdad',
      ianaTimeZoneId: 'Asia/Baghdad',
      windowsTimeZoneId: 'Arabic Standard Time',
    },
    {
      displayName: '(UTC+03:00) Damascus',
      ianaTimeZoneId: 'Asia/Damascus',
      windowsTimeZoneId: 'Syria Standard Time',
    },
    {
      displayName: '(UTC+03:00) Istanbul',
      ianaTimeZoneId: 'Europe/Istanbul',
      windowsTimeZoneId: 'Turkey Standard Time',
    },
    {
      displayName: '(UTC+03:00) Kuwait, Riyadh',
      ianaTimeZoneId: 'Asia/Riyadh',
      windowsTimeZoneId: 'Arab Standard Time',
    },
    {
      displayName: '(UTC+03:00) Minsk',
      ianaTimeZoneId: 'Europe/Minsk',
      windowsTimeZoneId: 'Belarus Standard Time',
    },
    {
      displayName: '(UTC+03:00) Moscow, St. Petersburg',
      ianaTimeZoneId: 'Europe/Moscow',
      windowsTimeZoneId: 'Russian Standard Time',
    },
    {
      displayName: '(UTC+03:00) Nairobi',
      ianaTimeZoneId: 'Africa/Nairobi',
      windowsTimeZoneId: 'E. Africa Standard Time',
    },
    {
      displayName: '(UTC+03:00) Volgograd',
      ianaTimeZoneId: 'Europe/Volgograd',
      windowsTimeZoneId: 'Volgograd Standard Time',
    },
    {
      displayName: '(UTC+03:30) Tehran',
      ianaTimeZoneId: 'Asia/Tehran',
      windowsTimeZoneId: 'Iran Standard Time',
    },
    {
      displayName: '(UTC+04:00) Abu Dhabi, Muscat',
      ianaTimeZoneId: 'Asia/Dubai',
      windowsTimeZoneId: 'Arabian Standard Time',
    },
    {
      displayName: '(UTC+04:00) Astrakhan, Ulyanovsk',
      ianaTimeZoneId: 'Europe/Astrakhan',
      windowsTimeZoneId: 'Astrakhan Standard Time',
    },
    {
      displayName: '(UTC+04:00) Baku',
      ianaTimeZoneId: 'Asia/Baku',
      windowsTimeZoneId: 'Azerbaijan Standard Time',
    },
    {
      displayName: '(UTC+04:00) Izhevsk, Samara',
      ianaTimeZoneId: 'Europe/Samara',
      windowsTimeZoneId: 'Russia Time Zone 3',
    },
    {
      displayName: '(UTC+04:00) Port Louis',
      ianaTimeZoneId: 'Indian/Mauritius',
      windowsTimeZoneId: 'Mauritius Standard Time',
    },
    {
      displayName: '(UTC+04:00) Saratov',
      ianaTimeZoneId: 'Europe/Saratov',
      windowsTimeZoneId: 'Saratov Standard Time',
    },
    {
      displayName: '(UTC+04:00) Tbilisi',
      ianaTimeZoneId: 'Asia/Tbilisi',
      windowsTimeZoneId: 'Georgian Standard Time',
    },
    {
      displayName: '(UTC+04:00) Yerevan',
      ianaTimeZoneId: 'Asia/Yerevan',
      windowsTimeZoneId: 'Caucasus Standard Time',
    },
    {
      displayName: '(UTC+04:30) Kabul',
      ianaTimeZoneId: 'Asia/Kabul',
      windowsTimeZoneId: 'Afghanistan Standard Time',
    },
    {
      displayName: '(UTC+05:00) Ashgabat, Tashkent',
      ianaTimeZoneId: 'Asia/Tashkent',
      windowsTimeZoneId: 'West Asia Standard Time',
    },
    {
      displayName: '(UTC+05:00) Astana',
      ianaTimeZoneId: 'Asia/Qyzylorda',
      windowsTimeZoneId: 'Qyzylorda Standard Time',
    },
    {
      displayName: '(UTC+05:00) Ekaterinburg',
      ianaTimeZoneId: 'Asia/Yekaterinburg',
      windowsTimeZoneId: 'Ekaterinburg Standard Time',
    },
    {
      displayName: '(UTC+05:00) Islamabad, Karachi',
      ianaTimeZoneId: 'Asia/Karachi',
      windowsTimeZoneId: 'Pakistan Standard Time',
    },
    {
      displayName: '(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi',
      ianaTimeZoneId: 'Asia/Kolkata',
      windowsTimeZoneId: 'India Standard Time',
    },
    {
      displayName: '(UTC+05:30) Sri Jayawardenepura',
      ianaTimeZoneId: 'Asia/Colombo',
      windowsTimeZoneId: 'Sri Lanka Standard Time',
    },
    {
      displayName: '(UTC+05:45) Kathmandu',
      ianaTimeZoneId: 'Asia/Kathmandu',
      windowsTimeZoneId: 'Nepal Standard Time',
    },
    {
      displayName: '(UTC+06:00) Bishkek',
      ianaTimeZoneId: 'Asia/Almaty',
      windowsTimeZoneId: 'Central Asia Standard Time',
    },
    {
      displayName: '(UTC+06:00) Dhaka',
      ianaTimeZoneId: 'Asia/Dhaka',
      windowsTimeZoneId: 'Bangladesh Standard Time',
    },
    {
      displayName: '(UTC+06:00) Omsk',
      ianaTimeZoneId: 'Asia/Omsk',
      windowsTimeZoneId: 'Omsk Standard Time',
    },
    {
      displayName: '(UTC+06:30) Yangon (Rangoon)',
      ianaTimeZoneId: 'Asia/Yangon',
      windowsTimeZoneId: 'Myanmar Standard Time',
    },
    {
      displayName: '(UTC+07:00) Bangkok, Hanoi, Jakarta',
      ianaTimeZoneId: 'Asia/Bangkok',
      windowsTimeZoneId: 'SE Asia Standard Time',
    },
    {
      displayName: '(UTC+07:00) Barnaul, Gorno-Altaysk',
      ianaTimeZoneId: 'Asia/Barnaul',
      windowsTimeZoneId: 'Altai Standard Time',
    },
    {
      displayName: '(UTC+07:00) Hovd',
      ianaTimeZoneId: 'Asia/Hovd',
      windowsTimeZoneId: 'W. Mongolia Standard Time',
    },
    {
      displayName: '(UTC+07:00) Krasnoyarsk',
      ianaTimeZoneId: 'Asia/Krasnoyarsk',
      windowsTimeZoneId: 'North Asia Standard Time',
    },
    {
      displayName: '(UTC+07:00) Novosibirsk',
      ianaTimeZoneId: 'Asia/Novosibirsk',
      windowsTimeZoneId: 'N. Central Asia Standard Time',
    },
    {
      displayName: '(UTC+07:00) Tomsk',
      ianaTimeZoneId: 'Asia/Tomsk',
      windowsTimeZoneId: 'Tomsk Standard Time',
    },
    {
      displayName: '(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi',
      ianaTimeZoneId: 'Asia/Shanghai',
      windowsTimeZoneId: 'China Standard Time',
    },
    {
      displayName: '(UTC+08:00) Irkutsk',
      ianaTimeZoneId: 'Asia/Irkutsk',
      windowsTimeZoneId: 'North Asia East Standard Time',
    },
    {
      displayName: '(UTC+08:00) Kuala Lumpur, Singapore',
      ianaTimeZoneId: 'Asia/Singapore',
      windowsTimeZoneId: 'Singapore Standard Time',
    },
    {
      displayName: '(UTC+08:00) Perth',
      ianaTimeZoneId: 'Australia/Perth',
      windowsTimeZoneId: 'W. Australia Standard Time',
    },
    {
      displayName: '(UTC+08:00) Taipei',
      ianaTimeZoneId: 'Asia/Taipei',
      windowsTimeZoneId: 'Taipei Standard Time',
    },
    {
      displayName: '(UTC+08:00) Ulaanbaatar',
      ianaTimeZoneId: 'Asia/Ulaanbaatar',
      windowsTimeZoneId: 'Ulaanbaatar Standard Time',
    },
    {
      displayName: '(UTC+08:45) Eucla',
      ianaTimeZoneId: 'Australia/Eucla',
      windowsTimeZoneId: 'Aus Central W. Standard Time',
    },
    {
      displayName: '(UTC+09:00) Chita',
      ianaTimeZoneId: 'Asia/Chita',
      windowsTimeZoneId: 'Transbaikal Standard Time',
    },
    {
      displayName: '(UTC+09:00) Osaka, Sapporo, Tokyo',
      ianaTimeZoneId: 'Asia/Tokyo',
      windowsTimeZoneId: 'Tokyo Standard Time',
    },
    {
      displayName: '(UTC+09:00) Pyongyang',
      ianaTimeZoneId: 'Asia/Pyongyang',
      windowsTimeZoneId: 'North Korea Standard Time',
    },
    {
      displayName: '(UTC+09:00) Seoul',
      ianaTimeZoneId: 'Asia/Seoul',
      windowsTimeZoneId: 'Korea Standard Time',
    },
    {
      displayName: '(UTC+09:00) Yakutsk',
      ianaTimeZoneId: 'Asia/Yakutsk',
      windowsTimeZoneId: 'Yakutsk Standard Time',
    },
    {
      displayName: '(UTC+09:30) Adelaide',
      ianaTimeZoneId: 'Australia/Adelaide',
      windowsTimeZoneId: 'Cen. Australia Standard Time',
    },
    {
      displayName: '(UTC+09:30) Darwin',
      ianaTimeZoneId: 'Australia/Darwin',
      windowsTimeZoneId: 'AUS Central Standard Time',
    },
    {
      displayName: '(UTC+10:00) Brisbane',
      ianaTimeZoneId: 'Australia/Brisbane',
      windowsTimeZoneId: 'E. Australia Standard Time',
    },
    {
      displayName: '(UTC+10:00) Canberra, Melbourne, Sydney',
      ianaTimeZoneId: 'Australia/Sydney',
      windowsTimeZoneId: 'AUS Eastern Standard Time',
    },
    {
      displayName: '(UTC+10:00) Guam, Port Moresby',
      ianaTimeZoneId: 'Pacific/Port_Moresby',
      windowsTimeZoneId: 'West Pacific Standard Time',
    },
    {
      displayName: '(UTC+10:00) Hobart',
      ianaTimeZoneId: 'Australia/Hobart',
      windowsTimeZoneId: 'Tasmania Standard Time',
    },
    {
      displayName: '(UTC+10:00) Vladivostok',
      ianaTimeZoneId: 'Asia/Vladivostok',
      windowsTimeZoneId: 'Vladivostok Standard Time',
    },
    {
      displayName: '(UTC+10:30) Lord Howe Island',
      ianaTimeZoneId: 'Australia/Lord_Howe',
      windowsTimeZoneId: 'Lord Howe Standard Time',
    },
    {
      displayName: '(UTC+11:00) Bougainville Island',
      ianaTimeZoneId: 'Pacific/Bougainville',
      windowsTimeZoneId: 'Bougainville Standard Time',
    },
    {
      displayName: '(UTC+11:00) Chokurdakh',
      ianaTimeZoneId: 'Asia/Srednekolymsk',
      windowsTimeZoneId: 'Russia Time Zone 10',
    },
    {
      displayName: '(UTC+11:00) Magadan',
      ianaTimeZoneId: 'Asia/Magadan',
      windowsTimeZoneId: 'Magadan Standard Time',
    },
    {
      displayName: '(UTC+11:00) Norfolk Island',
      ianaTimeZoneId: 'Pacific/Norfolk',
      windowsTimeZoneId: 'Norfolk Standard Time',
    },
    {
      displayName: '(UTC+11:00) Sakhalin',
      ianaTimeZoneId: 'Asia/Sakhalin',
      windowsTimeZoneId: 'Sakhalin Standard Time',
    },
    {
      displayName: '(UTC+11:00) Solomon Is., New Caledonia',
      ianaTimeZoneId: 'Pacific/Guadalcanal',
      windowsTimeZoneId: 'Central Pacific Standard Time',
    },
    {
      displayName: '(UTC+12:00) Anadyr, Petropavlovsk-Kamchatsky',
      ianaTimeZoneId: 'Asia/Kamchatka',
      windowsTimeZoneId: 'Russia Time Zone 11',
    },
    {
      displayName: '(UTC+12:00) Auckland, Wellington',
      ianaTimeZoneId: 'Pacific/Auckland',
      windowsTimeZoneId: 'New Zealand Standard Time',
    },
    {
      displayName: '(UTC+12:00) Coordinated Universal Time+12',
      ianaTimeZoneId: 'Etc/GMT-12',
      windowsTimeZoneId: 'UTC+12',
    },
    {
      displayName: '(UTC+12:00) Fiji',
      ianaTimeZoneId: 'Pacific/Fiji',
      windowsTimeZoneId: 'Fiji Standard Time',
    },
    {
      displayName: '(UTC+12:00) Petropavlovsk-Kamchatsky - Old',
      ianaTimeZoneId: 'Asia/Kamchatka',
      windowsTimeZoneId: 'Kamchatka Standard Time',
    },
    {
      displayName: '(UTC+12:45) Chatham Islands',
      ianaTimeZoneId: 'Pacific/Chatham',
      windowsTimeZoneId: 'Chatham Islands Standard Time',
    },
    {
      displayName: '(UTC+13:00) Coordinated Universal Time+13',
      ianaTimeZoneId: 'Etc/GMT-13',
      windowsTimeZoneId: 'UTC+13',
    },
    {
      displayName: "(UTC+13:00) Nuku'alofa",
      ianaTimeZoneId: 'Pacific/Tongatapu',
      windowsTimeZoneId: 'Tonga Standard Time',
    },
    {
      displayName: '(UTC+13:00) Samoa',
      ianaTimeZoneId: 'Pacific/Apia',
      windowsTimeZoneId: 'Samoa Standard Time',
    },
    {
      displayName: '(UTC+14:00) Kiritimati Island',
      ianaTimeZoneId: 'Pacific/Kiritimati',
      windowsTimeZoneId: 'Line Islands Standard Time',
    },
  ],
};
